import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcProductApiRoadmapPage } from 'src/app/model/page/ndc-product-api-roadmap-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-product-api-roadmap-page',
  templateUrl: './ndc-product-api-roadmap-page.component.html',
  styleUrls: ['./ndc-product-api-roadmap-page.component.scss']
})
export class NdcProductApiRoadmapPageComponent implements OnInit {
  ndcProductApiRoadmapPage: NdcProductApiRoadmapPage = {} as NdcProductApiRoadmapPage;
  quarterKeyValueMap = new Map();

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'product-api-roadmap') {
        this.ndcProductApiRoadmapPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcProductApiRoadmapPage.sections = [];
    this.ndcProductApiRoadmapPage.NdcProductApiRoadmapSections = [];

    const query = { 'fields.title': 'NDC Product API Roadmap' };
    this.contentfulService.getPageContentResponse(query).then((ndcProductApiRoadmapPageEntries) => {
      this.mapBanners(ndcProductApiRoadmapPageEntries.includes.Entry);
      this.mapPageInfo(ndcProductApiRoadmapPageEntries.items);
      this.mapSections(ndcProductApiRoadmapPageEntries.includes.Entry);
    });
  }

  private mapBanners(ndcProductApiRoadmapPageEntries: Entry<any>[]) {
    ndcProductApiRoadmapPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.ndcProductApiRoadmapPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.ndcProductApiRoadmapPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.ndcProductApiRoadmapPage.banner.url = entry.fields?.url;
      this.ndcProductApiRoadmapPage.banner.editorEmail = editorDetails?.pop();
      this.ndcProductApiRoadmapPage.banner.editorShortName = editorDetails?.pop();
      this.ndcProductApiRoadmapPage.banner.editorFullName = editorDetails?.pop();
      this.ndcProductApiRoadmapPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(ndcProductApiRoadmapPageEntries: Entry<any>[]) {
    ndcProductApiRoadmapPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['position']) {
          case 'MIDDLE':
            this.mapEntryToSection(entry);
            break;
          default:
            this.mapEntryToLeftRightSection(entry);
        }
      });

    this.ndcProductApiRoadmapPage.NdcProductApiRoadmapSections.sort((a, b) => b.order - a.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.ndcProductApiRoadmapPage.sections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapEntryToLeftRightSection(entry: Entry<any>) {
    // console.log(entry);

    
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.ndcProductApiRoadmapPage.NdcProductApiRoadmapSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      subBody: entry.fields['subBody'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string,
      position: entry.fields['position'] as string,
      category: entry.fields['category'] as string,
      sectionClass: entry.fields['sectionClass'] as string,
      roadmapYear: entry.fields['roadmapYear'] as string
    });
    // console.log('subbody', this.ndcProductApiRoadmapPage.NdcProductApiRoadmapSections);
  }
}
